export default __webpack_public_path__ + "static/media/utilization.230d454a.svg";